document.addEventListener('DOMContentLoaded', function () {
    var poll = setInterval(function () {
        if (!window.gsap || !window.ScrollTrigger) return;
        clearInterval(poll);

        var gsap = window.gsap;
        var ScrollTrigger = window.ScrollTrigger;

        document.querySelectorAll('.parallax-text-section').forEach(function (section) {
            var textWrapper = section.querySelector('.parallax-text-section__text');
            if (!textWrapper) return;

            // --- 1. Envolver cada sección InnerBlock en un sticky-wrapper ---
            Array.from(textWrapper.children).forEach(function (child) {
                // Evitar re-envolver si ya tiene el wrapper (por ejemplo en re-renders)
                if (child.classList.contains('parallax-text-section__sticky-wrapper')) return;

                var wrapper = document.createElement('div');
                wrapper.classList.add('parallax-text-section__sticky-wrapper');
                child.parentNode.insertBefore(wrapper, child);
                wrapper.appendChild(child);
            });

            // --- 2. Parallax + fade-in de imágenes de fondo ---
            section.querySelectorAll('[data-parallax="image"]').forEach(function (el) {
                var speed = parseFloat(el.dataset.parallaxSpeed) || -100;

                gsap.set(el, { opacity: 0.2 });

                gsap.to(el, {
                    y: speed,
                    ease: 'none',
                    scrollTrigger: {
                        trigger: section,
                        start: 'top bottom',
                        end: 'bottom top',
                        scrub: true,
                    },
                });

                gsap.to(el, {
                    opacity: 0.8,
                    ease: 'none',
                    scrollTrigger: {
                        trigger: el,
                        start: 'top 90%',
                        end: 'top 40%',
                        scrub: true,
                    },
                });
            });

            // --- 3. Fade-in de cada sección de texto al entrar en viewport ---
            textWrapper.querySelectorAll('.parallax-text-section__sticky-wrapper').forEach(function (wrapper) {
                var inner = wrapper.firstElementChild;
                if (!inner) return;

                gsap.set(inner, { opacity: 0 });

                gsap.to(inner, {
                    opacity: 1,
                    ease: 'none',
                    scrollTrigger: {
                        trigger: wrapper,
                        start: 'top 80%',
                        end: 'top 30%',
                        scrub: true,
                    },
                });
            });
        });
    }, 50);
});
